import { Card, Grid2, Typography } from "@mui/material";
import { PieChartCard } from "./PieChartCard";

const COLORS = ["#FB9B0B", "#f9f939", "#fd6b3a"];
export const EnquiryNps = ({ retailNps, notRetailNps }) => {
  return (
    <Grid2 container spacing={0} size={{ xs: 12 }}>
      <Card
        variant="outlined"
        sx={{
          boxShadow: 3,
          width: "100%",
          p: "15px",
          background: "#1d2637",
          color: "white",
          borderRadius: "12px",
          fontFamily: "Montserrat, serif !important",
        }}
      >
        <Typography
          sx={{ fontFamily: "Montserrat, serif !important" }}
          variant="body1"
          gutterBottom
        >
          NPS distribution at Enquiry Level
        </Typography>
        <Grid2 container size={{ xs: 12 }}>
          <Grid2 size={{ xs: 12, md: 6 }} md={{ color: "white" }}>
            <PieChartCard
              title={"Retailed NPS Category Distribution"}
              data={retailNps}
              colors={COLORS}
              innerRadius={70}
              outerRadius={100}
              boxShadow={0}
            />
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6 }} md={{ color: "white" }}>
            <PieChartCard
              title={"Not Retailed NPS Category Distribution"}
              data={notRetailNps}
              colors={["#00A6FB", "#006494", "#0582CA"]}
              innerRadius={70}
              outerRadius={100}
              boxShadow={0}
              centerTitle={true}
            />
          </Grid2>
        </Grid2>
      </Card>
    </Grid2>
  );
};
